<template>
    <div>
        <div
            v-for="(item, key) in items"
            :key="key"
            @click="item.method()"
            class="col-span-3 flex px-24 py-28 bg-white rounded-6 shadow relative transition-all hover:scale-110 cursor-pointer"
        >
            <div>
                <div class="flex items-center gap-16 mb-8">
                    <svg-icon
                        class="w-32 h-32"
                        :class="item.iconColor"
                        :type="item.icon"
                    />

                    <loading v-if="item.loading" class="min-h-48" size="small" />
                    <strong v-else class="text-big leading-none text-black">
                        {{ $numAbbr(item.count) }}
                    </strong>
                </div>

                <strong class="text-body text-black first-letter:uppercase">{{ item.title }}</strong>
                <p class="text-primary-80 text-body-sm first-letter:uppercase">{{ item.description }}</p>
            </div>
        </div>
    </div>
</template>


<script>
import SvgIcon from '../../components/ui/SvgIcon.vue';
import Loading from '../../components/ui/Loading';
import moment from 'moment';
import {mapStores, mapActions} from "pinia";
import {useDashboardStore} from "../../state/modules/dashboard";
import {useApplicationsStore} from '../../state/modules/applications';
import {useInterviewStore} from '../../state/modules/interviews';

export default {
    components: {Loading, SvgIcon},
    props: {
        applications: { type: Object },
    },
    data: function () {
        return {
            filter: {
                date_from: '',
                date_to: '',
                jobfunctions: [],
                rejected: [],
                new: false,
                hired: false,
                unrated: -1,
                score: false,
                score_min: 0,
                score_max: 100,
                sort: '-created_at',
                stages: [],
                text_keyword: '',
                tags: [],
                inclusiveTagMode: true,
                offices: [],
                referrals: [],
                favorites: false,
                stale: false,
                interview: false,
                unconfirmedInterview: false
            },
            interviewFilter: {
                date_from: '',
                date_to: '',
                new: false,
                hired: false,
                stages: [],
                users: [],
                tags: [],
                inclusiveTagMode: true,
                today: false,
                completed: false,
                statuses: [],
                jobfunctions: [],
            },
        };
    },
    computed: {
        ...mapStores(useDashboardStore),
        fetching() {
            return this.dashboardStore.fetching;
        },
        staleApplicationCount() {
            return this.dashboardStore.staleApplicationCount;
        },
        newApplicationCount() {
            return this.dashboardStore.newApplicationCount;
        },
        interviewApplicationCount() {
            return this.dashboardStore.interviewApplicationCount;
        },
        unconfirmedInterviewApplicationCount() {
            return this.dashboardStore.unconfirmedInterviewApplicationCount;
        },
        items() {
            return {
                stale: {
                    title: this.$t('applications.waiting_for_feedback'),
                    description: this.$t('applications.waiting_for_feedback_info'),
                    icon: 'custom-list',
                    iconColor: 'fill-semantic-warning',
                    count: this.staleApplicationCount,
                    loading: this.fetching.applicationsCount,
                    method: this.handleClickStale,
                },
                new: {
                    title: this.$t('analytics.new_applications'),
                    description: this.$t('applications.new_applications_info'),
                    icon: 'person-add',
                    iconColor: 'fill-semantic-info',
                    count: this.newApplicationCount,
                    loading: this.fetching.applicationsCount,
                    method: this.handleClickNew,
                },
                interview: {
                    title: this.$t('applications.planned_for_interview'),
                    description: this.$t('applications.planned_for_interview_info'),
                    icon: 'check-circle',
                    iconColor: 'fill-semantic-success',
                    count: this.interviewApplicationCount,
                    loading: this.fetching.applicationsCount,
                    method: this.handleClickInterview,
                },
                unconfirmedInterview: {
                    title: this.$t('applications.unplanned_for_interview'),
                    description: this.$t('applications.unplanned_for_interview_info'),
                    icon: 'unconfirmed-interview',
                    iconColor: 'fill-primary-60',
                    count: this.unconfirmedInterviewApplicationCount,
                    loading: this.fetching.applicationsCount,
                    method: this.handleClickUnconfirmedInterview,
                },
            }
        }
    },
    methods: {
        ...mapActions(useInterviewStore, { interviewSetFilterValues: 'setFilterValues' }),
        ...mapActions(useApplicationsStore, { applicationsSetFilterValues: 'setFilterValues' }),
        handleClickNew(){
            // this.filter.new = true;
            this.filter.date_from = moment().startOf('day');
            this.goToApplication();
        },
        handleClickStale(){
            this.filter.stale = true;
            this.goToApplication();
        },
        handleClickInterview(){
            this.interviewFilter.statuses = [2];
            this.interviewFilter.date_from = moment().startOf('day');
            this.goToInterview();
        },
        handleClickUnconfirmedInterview() {
            this.interviewFilter.statuses = [1,4,5];
            this.goToInterview();
        },
        goToApplication(){
            this.applicationsSetFilterValues(this.filter);
            this.$router.push({name: 'applications'});
        },
        goToInterview() {
            this.interviewSetFilterValues(this.interviewFilter);
            this.$router.push({name: 'interviews'});
        }
    },
};
</script>
